
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function MenuPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Schema.org JSON-LD for Service offerings
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "南森町鍼灸院",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/menu`,
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "治療料金",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "経絡治療 50分コース"
            },
            "price": "5000",
            "priceCurrency": "JPY"
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "経絡治療 90分コース"
            },
            "price": "9000",
            "priceCurrency": "JPY"
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "美容鍼 50分コース"
            },
            "price": "8000",
            "priceCurrency": "JPY"
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "小児鍼（乳幼児）"
            },
            "price": "1000",
            "priceCurrency": "JPY"
          }
        ]
      }
    });
    document.head.appendChild(script);

    // Set page title and meta description
    document.title = "治療料金 - 南森町鍼灸院";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '南森町鍼灸院の治療料金をご案内。経絡治療、美容鍼、小児鍼の料金体系を詳しく説明いたします。');
    }

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="shadow-sm border-b border-gray-100" style={{ backgroundColor: '#D8F25E' }}>
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center cursor-pointer">
              <div className="text-center">
                <h1
                  className="text-2xl md:text-4xl font-bold"
                  style={{
                    fontFamily: '"Hiragino Sans", "Noto Sans JP", sans-serif',
                    color: '#526D1A',
                  }}
                >
                  南森町鍼灸院
                </h1>
                <p className="mt-1 md:mt-2 text-sm md:text-lg opacity-90" style={{ color: '#526D1A' }}>
                  女性・小児専門（乳幼児〜小・中学生）
                </p>
              </div>
              <div className="ml-2 md:ml-0 -mt-2 md:-mt-4">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e2fcab9355782d68579ae8474689f655.webp"
                  alt="ハリネズミのマスコット"
                  className="w-16 h-16 md:w-28 md:h-28 object-contain"
                />
              </div>
            </Link>

            {/* デスクトップナビゲーション */}
            <nav className="hidden md:flex space-x-6 lg:space-x-8">
              <Link
                to="/"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                ホーム
              </Link>
              <Link
                to="/about"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                当院について
              </Link>
              <Link
                to="/menu"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer border-b-2 whitespace-nowrap"
                style={{ color: '#526D1A', borderColor: '#526D1A' }}
              >
                治療料金
              </Link>
              <Link
                to="/access"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                アクセス
              </Link>
              <Link
                to="/contact"
                className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ color: '#526D1A' }}
              >
                ご予約・お問い合わせ
              </Link>
            </nav>

            {/* モバイルメニューボタン */}
            <button
              className="md:hidden p-2 rounded-md cursor-pointer"
              style={{ color: '#526D1A' }}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* モバイルナビゲーション */}
          {isMobileMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col space-y-3">
                <Link
                  to="/"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ホーム
                </Link>
                <Link
                  to="/about"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  当院について
                </Link>
                <Link
                  to="/menu"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2 border-b-2"
                  style={{ color: '#526D1A', borderColor: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  治療料金
                </Link>
                <Link
                  to="/access"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  アクセス
                </Link>
                <Link
                  to="/contact"
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2"
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ご予約・お問い合わせ
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* ページタイトル */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#526D1A' }}>
            治療料金
          </h1>
          <p className="text-lg text-gray-600">当院の治療料金とご案内</p>
        </div>

        {/* 治療の流れ */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>
            治療の流れ
          </h2>
          <p className="text-center text-lg text-gray-600 mb-12">
            初診から治療完了まで、安心してお受けいただける流れをご説明いたします
          </p>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              {
                step: '1',
                title: '問診',
                description:
                  '現在の症状や過去の病歴、生活習慣について詳しくお伺いします。お悩みやご希望を丁寧にヒアリングいたします。',
                icon: 'ri-chat-3-line',
              },
              {
                step: '2',
                title: '脈診',
                description: '脈の状態から身体の状態を読み取り、本治法で脈を整えていきます。',
                icon: 'ri-stethoscope-line',
              },
              {
                step: '3',
                title: '鍼治療',
                description: '標治法で、不調があらわれている部位に鍼をして、症状の改善を図ります。',
                icon: 'ri-file-text-line',
              },
              {
                step: '4',
                title: '治療後のご案内',
                description: '治療後の注意点や養生法をお伝えします。',
                icon: 'ri-heart-pulse-line',
              },
            ].map((flow, index) => (
              <div key={index} className="text-center">
                <div
                  className="bg-white rounded-lg shadow-md p-6 border-t-4 h-full"
                  style={{ borderTopColor: index % 2 === 0 ? '#526D1A' : '#D8F25E' }}
                >
                  <div
                    className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full"
                    style={{ backgroundColor: index % 2 === 0 ? '#526D1A' : '#D8F25E' }}
                  >
                    <span className="text-2xl font-bold text-white">{flow.step}</span>
                  </div>
                  <i className={`${flow.icon} text-3xl mb-3`} style={{ color: '#526D1A' }}></i>
                  <h3 className="text-lg font-semibold mb-3" style={{ color: '#526D1A' }}>
                    {flow.title}
                  </h3>
                  <p className="text-sm text-gray-600">{flow.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* 本治法・標治法の説明 */}
          <div className="mt-16 grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-search-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>
                    本治法
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">
                    東洋医学の古典には、「病を治するには、まずその本（もと）を求めよ」と記されています。
                    本治法では、体の不調を「気・血・水」や「陰陽」、「経絡」の乱れによって起こるものと考えます。
                    症状を引き起こしている体の内側のバランスを整えることで、自然治癒力を高め、根本からの改善を目指します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-focus-3-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>
                    標治法
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">
                    標治法とは、今あらわれている症状に対して行う治療です。たとえば、肩こり・腰痛・頭痛など、つらい症状に対して的確に鍼を施し、痛みや不快感を改善していきます。一方で、本治法が「体質や根本の乱れを整える治療」であるのに対し、標治法は「現れている不調そのもの」に働きかけます。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 治療法の組み合わせ説明 */}
          <div className="mt-8 text-center">
            <p className="text-lg text-gray-700 font-medium">
              この二つの治療法を組み合わせることで、症状の改善と再発しにくい体づくりをめざします。
            </p>
          </div>
        </section>

        {/* 料金表 */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>
            料金表
          </h2>

          {/* 基本料金 */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: '#526D1A' }}>
              基本料金
            </h3>
            <div className="max-w-md mx-auto">
              <div
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: '#526D1A' }}
              >
                <h4 className="text-xl font-semibold mb-2" style={{ color: '#526D1A' }}>
                  初診料
                </h4>
                <p className="text-3xl font-bold text-gray-800">1,000円</p>
                <p className="text-sm text-gray-600 mt-2">（税込）</p>
              </div>
            </div>
          </div>

          {/* 一般治療 */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: '#526D1A' }}>
              一般治療
            </h3>
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              <div
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: '#D8F25E' }}
              >
                <div className="mb-4">
                  <img
                    src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/47f729b9bda300dec138e3cff9a60106.png"
                    alt="経絡治療50分コース"
                    className="w-20 h-16 object-cover rounded-lg mx-auto"
                  />
                </div>
                <h4 className="text-xl font-semibold mb-2" style={{ color: '#526D1A' }}>
                  経絡治療 50分コース
                </h4>
                <p className="text-sm text-gray-600 mb-2">50分</p>
                <p className="text-3xl font-bold text-gray-800">5,000円</p>
                <p className="text-sm text-gray-600">（税込）</p>
              </div>

              <div
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: '#526D1A' }}
              >
                <div className="mb-4">
                  <img
                    src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/cf296c56abf47e296d80bd18ccc81d27.png"
                    alt="経絡治療90分コース"
                    className="w-20 h-16 object-cover rounded-lg mx-auto"
                  />
                </div>
                <h4 className="text-xl font-semibold mb-2" style={{ color: '#526D1A' }}>
                  経絡治療 90分コース
                </h4>
                <p className="text-sm text-gray-600 mb-2">90分</p>
                <p className="text-3xl font-bold text-gray-800">9,000円</p>
                <p className="text-sm text-gray-600">（税込）</p>
              </div>
            </div>
          </div>

          {/* 美容鍼 */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: '#526D1A' }}>
              美容鍼
            </h3>
            <div
              className="bg-white rounded-lg shadow-lg p-8 border-t-4"
              style={{ borderTopColor: '#D8F25E' }}
            >
              <div className="text-center mb-6">
                <div className="mb-4">
                  <img
                    src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/41ca03fadd6134b358df0e16cef6cdf9.png"
                    alt="美容鍼の様子"
                    className="w-24 h-20 object-cover rounded-lg mx-auto"
                  />
                </div>
                <h4 className="text-2xl font-bold mb-4" style={{ color: '#526D1A' }}>
                  美容鍼 50分コース
                </h4>
                <p className="text-sm text-gray-600 mb-2">50分</p>
              </div>

              <div className="grid md:grid-cols-3 gap-6">
                {/* 単発料金 */}
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <h5 className="text-lg font-semibold mb-2" style={{ color: '#526D1A' }}>
                    単発料金
                  </h5>
                  <p className="text-2xl font-bold text-gray-800 mb-1">8,000円</p>
                  <p className="text-sm text-red-600 font-medium">初回　5,000円</p>
                  <p className="text-xs text-gray-600">
                    ※初回は5,000円、２回目以降は8,000円になります。
                  </p>
                </div>

                {/* 5回券 */}
                <div
                  className="text-center p-4 bg-yellow-50 rounded-lg border-2"
                  style={{ borderColor: '#D8F25E' }}
                >
                  <h5 className="text-lg font-semibold mb-2" style={{ color: '#526D1A' }}>
                    5回券
                  </h5>
                  <div className="mb-2">
                    <p className="text-sm text-gray-500 line-through">40,000円</p>
                    <p className="text-2xl font-bold text-red-600">25,000円</p>
                  </div>
                  <p className="text-sm text-gray-600">1回あたり 5,000円</p>
                  <div className="mt-2 px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full inline-block">
                    15,000円お得
                  </div>
                </div>

                {/* 10回券 */}
                <div
                  className="text-center p-4 bg-yellow-50 rounded-lg border-2"
                  style={{ borderColor: '#D8F25E' }}
                >
                  <h5 className="text-lg font-semibold mb-2" style={{ color: '#526D1A' }}>
                    10回券
                  </h5>
                  <div className="mb-2">
                    <p className="text-sm text-gray-500 line-through">80,000円</p>
                    <p className="text-2xl font-bold text-red-600">50,000円</p>
                  </div>
                  <p className="text-sm text-gray-600">1回あたり 5,000円</p>
                  <div className="mt-2 px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full inline-block">
                    30,000円お得
                  </div>
                </div>
              </div>

              <div className="mt-6 text-center">
                <p className="text-sm text-gray-600">
                  ※チケットのご購入で、5回40,000円→25,000円、10回80,000円→50,000円
                </p>
              </div>
            </div>
          </div>

          {/* 小児鍼 */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: '#526D1A' }}>
              小児鍼
            </h3>
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: '#D8F25E' }}
              >
                <h4 className="text-xl font-semibold mb-2" style={{ color: '#526D1A' }}>
                  乳幼児
                </h4>
                <p className="text-sm text-gray-600 mb-2">15分</p>
                <p className="text-3xl font-bold text-gray-800">1,000円</p>
                <p className="text-sm text-gray-600">（税込）</p>
              </div>

              <div
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: '#526D1A' }}
              >
                <h4 className="text-xl font-semibold mb-2" style={{ color: '#526D1A' }}>
                  小学生
                </h4>
                <p className="text-sm text-gray-600 mb-2">20分</p>
                <p className="text-3xl font-bold text-gray-800">2,000円</p>
                <p className="text-sm text-gray-600">（税込）</p>
              </div>

              <div
                className="bg-white rounded-lg shadow-md p-6 text-center border-t-4"
                style={{ borderTopColor: '#D8F25E' }}
              >
                <h4 className="text-xl font-semibold mb-2" style={{ color: '#526D1A' }}>
                  中学生
                </h4>
                <p className="text-sm text-gray-600 mb-2">30分</p>
                <p className="text-3xl font-bold text-gray-800">3,000円</p>
                <p className="text-sm text-gray-600">（税込）</p>
              </div>
            </div>
          </div>
        </section>

        {/* 料金に関するご案内 */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>
            料金に関するご案内
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start">
                <i className="ri-money-dollar-circle-line text-2xl mr-3 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#526D1A' }}>
                    自費診療
                  </h3>
                  <p className="text-gray-700">当院は自費診療のみとなります。</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start">
                <i className="ri-calendar-close-line text-2xl mr-3 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#526D1A' }}>
                    キャンセルポリシー
                  </h3>
                  <p className="text-gray-700">
                    ご予約の変更・キャンセルは、前日の営業時間内までにご連絡ください。当日のキャンセルにつきましては、キャンセル料として治療料金の100%を申し受ける場合がございます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA セクション */}
        <section className="text-center">
          <div
            className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto"
            style={{ backgroundColor: '#D8F25E' }}
          >
            <h2 className="text-3xl font-bold mb-6" style={{ color: '#526D1A' }}>
              ご予約・お問い合わせ
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              まずはお気軽にご予約ください。<br />初めての方にも安心して受けていただけるよう、丁寧にお話しを伺います。
            </p>

            <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
              <button
                className="bg-white text-white px-8 py-4 rounded-full text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
                style={{
                  backgroundColor: '#526D1A',
                  border: '3px solid #526D1A',
                }}
                onClick={() => {
                  window.open('https://kenkounihari.seirin.jp/clinic/18451/reserve', '_blank');
                }}
              >
                <i className="ri-calendar-line mr-3"></i>
                今すぐ予約する
              </button>

              <Link
                to="/contact"
                className="bg-white px-8 py-4 rounded-full text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105 border-3"
                style={{
                  color: '#526D1A',
                  borderColor: '#526D1A',
                }}
              >
                <i className="ri-mail-line mr-3"></i>
                お問い合わせ
              </Link>
            </div>
          </div>
        </section>
      </div>

      {/* フッター */}
      <footer className="mt-16 py-8 text-center text-gray-600" style={{ backgroundColor: '#f8f9f0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <p>&copy; 2025 南森町鍼灸院. All rights reserved.</p>
          <p className="mt-2">
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500"
            >
              Powered by Readdy AI
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
